import React, { FC } from 'react'
import Title from 'Components/Shared/Title/Title'
// import { CellDataType } from 'types'
import BasketRow from '../BasketRow/BasketRow'
import { BasketCardStyle, BasketCardRow } from './BasketCardStyle'

/**
 * CardProps contains all appropriate props we should pass to nested components.
 */
export interface BasketCardProps {
  title: string
  subtitle?: string
  cardImage?: string
  // pcwCard?: boolean
  // pcwCardproperties?: CellDataType
}

/**
 * BasketCard is used to wrap all components we render in order to display selected Card.
 * ThemeProvider component is used. By using the theme object we provide same styling options to all components.
 */
const BasketCard: FC<BasketCardProps> = ({
  title,
  cardImage,
  subtitle,
  // pcwCard,
}) => (
  <BasketCardRow>
    <BasketCardStyle>
      <BasketRow
        text={title}
        image={cardImage} /* verticalDirection={pcwCard} */
      />
      <Title subtitle>
        {subtitle !== undefined && (
          <div dangerouslySetInnerHTML={{ __html: subtitle }} />
        )}
      </Title>
    </BasketCardStyle>
  </BasketCardRow>
)

export default BasketCard
